<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { pending, syncing, flushQueue } from '@/lib/sync'

const { t } = useI18n()

const online = ref(navigator.onLine)
const update = () => (online.value = navigator.onLine)

onMounted(() => {
  window.addEventListener('online', update)
  window.addEventListener('offline', update)
})
onUnmounted(() => {
  window.removeEventListener('online', update)
  window.removeEventListener('offline', update)
})

const text = computed(() => {
  if (!online.value) return t('offline.offline')
  if (syncing.value) return t('offline.syncing')
  if (pending.value > 0) return t('offline.pending', pending.value)
  return null
})
const colorClass = computed(() => {
  if (!online.value) return 'bg-amber-500 text-white'
  if (pending.value > 0 || syncing.value) return 'bg-sky-500 text-white'
  return ''
})
</script>

<template>
  <button
    v-if="text"
    class="fixed top-2 right-2 z-50 rounded-full px-3 py-1 text-xs font-medium shadow"
    :class="colorClass"
    @click="flushQueue()"
  >
    {{ text }}
  </button>
</template>
